import React from 'react';
import { Handle, Position } from 'reactflow';
import type { NodeToRenderProps, NodeToRenderData } from '@src/components/custom-nodes/types';

const defaultAdjustment = {
  l: 0,
  t: 0,
  r: 0,
  b: 0,
}
interface Adjustment {
  l?: number;
  t?: number;
  r?: number;
  b?: number;
}
export const withHandles = ({ l, t, r, b }: Adjustment = defaultAdjustment) => (WrappedComponent: React.FC<NodeToRenderProps>) => {
  return function WithHandlesWrapper(props: NodeToRenderProps) {
    const handles = (props?.data as NodeToRenderData)?.handles ?? {};
    return (
      <div>
        <WrappedComponent {...props}>
          {props.children}
        </WrappedComponent>
        {handles.l ? <Handle id={Position.Left} style={{ left: l ?? 0 }} className="opacity-0 !pointer-events-none" type="target" position={Position.Left} /> : null}
        {handles.t ? <Handle id={Position.Top} style={{ top: t ?? 0 }} className="opacity-0 !pointer-events-none" type="target" position={Position.Top} /> : null}
        {handles.r ? <Handle id={Position.Right} style={{ right: r ?? 0 }} className="opacity-0 !pointer-events-none" type="target" position={Position.Right} /> : null}
        {handles.b ? <Handle id={Position.Bottom} style={{ bottom: b ?? 0 }} className="opacity-0 !pointer-events-none" type="source" position={Position.Bottom} /> : null}
      </div>
    );
  };
}
